<template>
    <div>
        <h6 class="text-muted mb-2">
            <span class="mr-2">
                {{ $t('nBox.form.defineTargetValue') }}
            </span>
            <i
                v-b-tooltip.hover
                class="far fa-question-circle"
                :title="$t('nBox.form.targetValueDescription')"
            />
        </h6>
        <div class="d-flex">
            <Limit
                class="mr-5"
                axis="x"
                :value="xAxis"
                :limits="limits.x"
                :validation="validations.x"
                @change="$emit('update:xAxis', $event)"
            />
            <Limit
                axis="y"
                :value="yAxis"
                :limits="limits.y"
                :validation="validations.y"
                @change="$emit('update:yAxis', $event)"
            />
        </div>
    </div>
</template>
<script>
import { min, max } from 'lodash'
import Limit from './components/Limit'
export default {
    components: {
        Limit,
    },
    props: {
        xAxis: {
            type: [String, Number],
            default: null,
        },
        yAxis: {
            type: [String, Number],
            default: null,
        },
        validations: {
            type: Object,
            required: true,
        },
        quadrants: {
            type: Array,
            required: () => [],
        },
    },
    computed: {
        limits() {
            return ['x', 'y'].reduce((object, key) => {
                return {
                    ...object,
                    [key]: {
                        min: min(this.quadrants.map(v => v[`${key}_min`])),
                        max: max(this.quadrants.map(v => v[`${key}_max`])),
                    },
                }
            }, {})
        },
    },
}
</script>
<style scoped>
::v-deep .form-group {
    margin-bottom: 0;
    margin-left: 0.5rem;
}

::v-deep input[type='number'] {
    width: 100px;
}

.fa-question-circle {
    color: gray;
}
</style>
